// extracted by mini-css-extract-plugin
export default {"intro":"intro__2ogrm"};